// extracted by mini-css-extract-plugin
export default {"wrapper":"ListingLayout_wrapper__-2qEo","listing":"ListingLayout_listing__Ov1y+"};